(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    const target = event.target;

    const openDetails = document.querySelectorAll(
      'details[data-auto-close-details][open]'
    );

    for (const element of openDetails) {
      const autoClose = element.getAttribute('data-auto-close-details');

      if (!autoClose || !autoClose.includes(closingOn)) continue;

      if (target instanceof Node && element.contains(target)) continue;

      element.removeAttribute('open');
    }
  });
})();